/* Kleine IndexedDB-Hülle für die Offline-Outbox (ohne externe Abhängigkeit). */
const DB_NAME = "mps-offline";
const DB_VERSION = 1;
const STORE = "outbox";

let dbPromise = null;

const openDb = () => {
  if (dbPromise) return dbPromise;
  dbPromise = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "id" });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbPromise;
};

const tx = async (mode, fn) => {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE, mode);
    const store = transaction.objectStore(STORE);
    let result;
    try {
      result = fn(store);
    } catch (err) {
      reject(err);
      return;
    }
    transaction.oncomplete = () => resolve(result?.result ?? result);
    transaction.onerror = () => reject(transaction.error);
  });
};

export const addEntry = (entry) => tx("readwrite", (store) => store.add(entry));

export const putEntry = (entry) => tx("readwrite", (store) => store.put(entry));

export const deleteEntry = (id) => tx("readwrite", (store) => store.delete(id));

export const getEntries = async () => {
  const res = await tx("readonly", (store) => store.getAll());
  const list = res || [];
  return list.sort((a, b) => (a.created_at > b.created_at ? 1 : -1));
};

export const getEntry = (id) => tx("readonly", (store) => store.get(id));

export const isSupported = () => typeof indexedDB !== "undefined";
